import { DeleteOutlined, EditOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Modal, Popconfirm, Row, Select, Space, Spin, Tooltip, Typography, Upload } from "antd";
import React, { useEffect, useState } from "react";
import TableView from "../../../contents/AntTableResponsive";
import { useStoreActions, useStoreState } from "../../../store/hooks/easyPeasy";

const { Option } = Select;

export default function DistinguishTeacher() {
    const { Title } = Typography;

    const [isModalVisible, setIsModalVisible] = useState<any>();
    const [form] = Form.useForm();
    const [updateForm] = Form.useForm();

    // Save file states
    const [fileList, setFileList] = useState<any>([]);
    const [fileSave, setFileSave] = useState<boolean>(false);
    const [fileContent, setFileContent] = useState<any>("");
    const [fileType, setFileType] = useState<any>("");
    const [start, setStart] = useState<boolean>(false);
    // Update file states
    const [fileListUpdate, setFileListUpdate] = useState<any>([]);
    const [fileContentUpdate, setFileContentUpdate] = useState<any>("");
    const [fileTypeUpdate, setFileTypeUpdate] = useState<any>("");
    const [startUpdate, setStartUpdate] = useState<boolean>(false);
    const [teacherId, setTeacherId] = useState<any>("");

    const fetchDistinguishTeacherList = useStoreActions((state) => state.pages.fetchDistinguishTeacherList);
    const distinguishTeacherList = useStoreState((state) => state.pages.distinguishTeacherList);
    const storeDistinguishTeacher = useStoreActions((state) => state.pages.storeDistinguishTeacher);
    const updateDistinguishTeacher = useStoreActions((state) => state.pages.updateDistinguishTeacher);
    const deleteDistinguishTeacher = useStoreActions((state) => state.pages.deleteDistinguishTeacher);

    useEffect(() => { fetchDistinguishTeacherList(); }, []);

    const onChangeFile = ({ fileList: newFileList }) => {
        if (newFileList.length === 1) {
            setStart(true);
            newFileList[0].status = "done";
            setFileSave(true);
            setFileType(newFileList[0]?.name?.split(".").pop());
            const reader: any = new FileReader();
            reader.readAsDataURL(newFileList[0]?.originFileObj);
            setTimeout(() => { setFileContent(reader.result?.split(",")[1]); setStart(false); }, 2000);
        }
        setFileList(newFileList);
    };

    const onChangeFileUpdate = ({ fileList: newList }) => {
        if (newList.length === 1) {
            setStartUpdate(true);
            newList[0].status = "done";
            setFileTypeUpdate(newList[0]?.name?.split(".").pop());
            const reader: any = new FileReader();
            reader.readAsDataURL(newList[0]?.originFileObj);
            setTimeout(() => { setFileContentUpdate(reader.result?.split(",")[1]); setStartUpdate(false); }, 2000);
        }
        setFileListUpdate(newList);
    };

    const handleCancel = () => {
        setFileContentUpdate(""); setFileTypeUpdate(""); setFileListUpdate([]);
        setIsModalVisible(false);
    };

    const onSaveSubmit = (value) => {
        storeDistinguishTeacher({
            teacherTitle: value.teacherTitle,
            teacherDescription: value.teacherDescription,
            fileSave: fileSave,
            fileContent: fileContent,
            fileType: fileType,
        });
        form.resetFields();
        setFileList([]); setFileContent(""); setFileType(""); setFileSave(false);
    };

    const onUpdateSubmit = (value) => {
        updateDistinguishTeacher({
            id: teacherId,
            teacherTitle: value.teacherTitleUpdate,
            teacherDescription: value.teacherDescriptionUpdate,
            fileSave: fileContentUpdate !== "" ? true : false,
            fileContent: fileContentUpdate,
            fileType: fileTypeUpdate,
        });
        setFileContentUpdate(""); setFileTypeUpdate(""); setFileListUpdate([]);
        setIsModalVisible(false);
    };

    const columns = [
        { title: "Title", dataIndex: "teacherTitle", key: "teacherTitle", showOnResponse: true, showOnDesktop: true },
        { title: "Description", dataIndex: "teacherDescription", key: "teacherDescription", showOnResponse: true, showOnDesktop: true },
        {
            title: "File", dataIndex: "teacherFileViewerLink", key: "teacherFileViewerLink", showOnResponse: true, showOnDesktop: true,
            render: (_: any, record: any) => record?.teacherFileViewerLink
                ? record?.fileViewerLink?.match(/\.(jpg|jpeg|png|gif)$/i)
                    ? <img src={record?.teacherFileViewerLink} alt="teacher" height="60" />
                    : <a href={record?.teacherFileLink} target="_blank" rel="noreferrer">{record?.teacherFileName}</a>
                : "-"
        },

        { title: 'Photo', dataIndex: 'teacherFileLink', key: 'teacherFileLink', showOnResponse: true, showOnDesktop: true ,
        render: (text: any, record: any, index) => (
            <>
                <img
                    src={record?.teacherFileLink}
                    height="120"
                />
            </>
        )},

        {
            title: "Action", dataIndex: "id", key: "id", showOnResponse: true, showOnDesktop: true,
            render: (_: any, record: any) => (
                <Space size="middle">
                    <Tooltip title="Edit">
                        <Button type="primary" icon={<EditOutlined />} onClick={() => {
                            setIsModalVisible(true);
                            setTeacherId(record?.id);
                            setFileContentUpdate(""); setFileTypeUpdate(""); setFileListUpdate([]);
                            updateForm.setFieldsValue({
                                teacherTitleUpdate: record?.teacherTitle,
                                teacherDescriptionUpdate: record?.teacherDescription,
                            });
                        }} />
                    </Tooltip>
                    <Popconfirm title="Are you sure to delete this?" okText="Yes" cancelText="No"
                        onConfirm={() => deleteDistinguishTeacher(record?.id)}>
                        <Tooltip title="Delete">
                            <Button danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            )
        },
    ];

    return (
        <>
            <Card title="Distinguish Teacher">
                <Row>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                        <Form layout="vertical" id="distinguishTeacherSaveForm" form={form} onFinish={onSaveSubmit}>
                            <Row gutter={[16, 0]}>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }}>
                                    <Form.Item name="teacherTitle" label="Teacher Title" className="title-Text"
                                        style={{ width: "100%" }}
                                        rules={[{ required: true, message: "Please enter the title" }]}>
                                        <Input placeholder="Enter teacher title" />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }}>
                                    <Form.Item name="teacherDescription" label="Teacher Description" className="title-Text"
                                        style={{ width: "100%" }}>
                                        <Input.TextArea rows={1} placeholder="Enter description" />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }}>
                                    <Form.Item name="saveUploadFile" label="Photo" className="title-Text"
                                        style={{ width: "100%" }}>
                                        <Spin tip="Uploading..." spinning={start}>
                                            <Upload listType="picture" accept="image/png, image/jpeg" fileList={fileList} onChange={onChangeFile}>
                                                {fileList.length < 1 && <Button icon={<UploadOutlined />}>Upload</Button>}
                                            </Upload>
                                        </Spin>
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                                    <Button type="primary" htmlType="submit" style={{ float: "right" }}>Save</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row className="m-t-mo-30">
                    <Col span={24}>
                        <TableView
                            antTableProps={{
                                showHeader: true,
                                columns,
                                dataSource: distinguishTeacherList,
                                filterData: distinguishTeacherList,
                                pagination: true,
                                bordered: true,
                                rowKey: "id",
                            }}
                            mobileBreakPoint={768}
                        />
                    </Col>
                </Row>
            </Card>

            <Modal title="Update Distinguish Teacher" visible={isModalVisible} onCancel={handleCancel} footer={null} width={700}>
                <Form layout="vertical" form={updateForm} onFinish={onUpdateSubmit} id="distinguishTeacherUpdateForm">
                    <Row gutter={[16, 0]}>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
                            <Form.Item name="teacherTitleUpdate" label="Teacher Title" className="title-Text"
                                style={{ width: "100%" }}
                                rules={[{ required: true, message: "Please enter the title" }]}>
                                <Input placeholder="Enter teacher title" />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
                            <Form.Item name="teacherDescriptionUpdate" label="Teacher Description" className="title-Text"
                                style={{ width: "100%" }}>
                                <Input.TextArea rows={2} placeholder="Enter description" />
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
                            <Form.Item name="updateUploadFile" label="Photo" className="title-Text"
                                style={{ width: "100%" }}>
                                <Spin tip="Uploading..." spinning={startUpdate}>
                                    <Upload listType="picture" accept="image/png, image/jpeg" fileList={fileListUpdate} onChange={onChangeFileUpdate}>
                                        {fileListUpdate.length < 1 && <Button icon={<UploadOutlined />}>Upload</Button>}
                                    </Upload>
                                </Spin>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }}>
                            <Button type="primary" htmlType="submit" style={{ float: "right" }}>Update</Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}

